// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify);

export default new Vuetify({
   theme: {
      themes: {
         light: {
            primary: '#607d8b',
            secondary: '#795548',
            accent: '#3f51b5',
            error: '#f44336',
            warning: '#ff9800',
            info: '#03a9f4',
            success: '#009688'
         }
      },
   }
});
